import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SidebarComponent from '../common/sidebar-component';
import OrganisationResultsContext from './context';
import SidebarComponentHeader from '../common/sidebar/sidebar-component-header';
import useGetContributors from '../../../services/contributors/from-organisation-service';
import NanoProfile from '../common/nano-profile';

const ContributorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-top: 20px;
`;

export default function Contributors({ organisation }) {
  const { dispatch } = React.useContext(OrganisationResultsContext);
  const [{ data }, executeQuery] = useGetContributors(organisation, 3);

  React.useEffect(() => {
    executeQuery();
  }, [executeQuery]);

  React.useEffect(() => {
    if (_.get(data, 'contributors.length')) {
      dispatch({ type: 'setContributors', payload: data.contributors });
    }
  }, [data, dispatch]);

  if (!_.get(data, 'contributors.length')) {
    return null;
  }

  return (
    <SidebarComponent>
      <SidebarComponentHeader
        title="contributors from"
        query={organisation}
      />
      <ContributorsContainer>
        {data.contributors.map(p => (
          <NanoProfile key={`contributor-${p.id}`} profile={p} dark small />
        ))}
      </ContributorsContainer>
    </SidebarComponent>
  );
}

Contributors.propTypes = {
  organisation: PropTypes.string.isRequired,
};
